import { ResourceError } from 'ia-react-core/~/interfaces/ResourceError';
import Action from '../#Action';

export default class RequestResourceFailureByName extends Action {
  /** The action namespace */
  static namespace = 'Core/Resource';

  static type = 'Core/Resource/RequestResourceFailureByName';

  static identifier = 'name';

  name: string;
  error: ResourceError;

  constructor(name: string, error: ResourceError) {
    super();
    this.type = `${(this.constructor as typeof RequestResourceFailureByName).type}/${name}`;
    this.name = name;
    this.error = error;
  }
}
